'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _hi_IN = require('../../vc-calendar/src/locale/hi_IN');

var _hi_IN2 = _interopRequireDefault(_hi_IN);

var _hi_IN3 = require('../../time-picker/locale/hi_IN');

var _hi_IN4 = _interopRequireDefault(_hi_IN3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

// Merge into a locale object
var locale = {
  lang: (0, _extends3['default'])({
    placeholder: 'तारीख़ चुनें',
    rangePlaceholder: ['प्रारंभ तिथि', 'समाप्ति तिथि']
  }, _hi_IN2['default']),
  timePickerLocale: (0, _extends3['default'])({}, _hi_IN4['default'])
};

// All settings at:
// https://github.com/ant-design/ant-design/blob/master/components/date-picker/locale/example.json

exports['default'] = locale;